export default {
    prefs: {
        menuItemTitle: 'Establecer Preferencias',
        dialogTitle: 'Establecer Preferencias de Usuario',
        alarmColorsLabel: 'Colores de Alarmas',
        uiColorsLabel: 'Colores de Usuario',
        graphColorsLabel: 'Colores del Gráfico',
        colors: 'Colores',
        colorTheme: 'Tema de Color',
        graphLineMarkers: 'Marcadores de Líneas Gráficas',
        mapBillboardsToDots: 'Cambie automáticamente los iconos a puntos al hacer zoom',
        mapClearCacheOnExit: 'Borrar caché de mapa al salir',
        mapExportIncludeLabels: 'Incluir etiqueta en la exportación de mapas',
        toasterMsgTime: 'Tiempo de visualización del mensaje de la tostadora',
        pageRefreshInterval: 'Intervalo de actualización automática del mapa',
        idAndNameDisplay: 'Visualización de Nombre e Identificación',
        idAndNameOptions: {
            id: 'Mostrar ID Solamente',
            name: 'Mostrar Nombre Solamente',
            both: 'Mostrar ID y Nombre'
        },
        graphLineMarkerOptions: {
            disable: 'Desactivar Marcadores de Línea',
            enable: 'Mostrar Marcadores de Línea Cuando el Espacio lo Permite'
        },
        mapBillboardsToDotsOptions: {
            disable: 'No cambiar automáticamente',
            enable: 'Cambiar automáticamente'
        },
        clearMapCacheOnExitOptions: {
            disable: 'No',
            enable: 'sí'
        },
        mapExportIncludeLabelsOptions: {
            disable: 'No',
            enable: 'sí'
        },
        colorThemes: {
            NCSLight: 'Default',
            NCSLightAccessible1: 'Accessible',
            NCSDark: 'Dark'
        },
        alarmColors: {
            critical: 'Crítico',
            major: 'Mayor',
            minor: 'Menor',
            info: 'Info',
            unknown: 'Desconocido',
            none: 'Ninguno'
        },
        uiColors: {
            primary: 'Primario',
            secondary: 'Secundario',
            accent: 'Acento',
            error: 'Error',
            warning: 'Advertencia',
            info: 'Info',
            success: 'Éxito',
            dashletHdrBg: 'Tablero'
        },
        units: "Unidades",
        duration: {
            title: 'Duración predeterminada del gráfico',
            days1IntervalHourly: 'Últimas 24 horas, cada hora',
            days7IntervalHourly: 'Últimos 7 días, cada hora',
            days7IntervalDaily: 'Últimos 7 días, diario',
            days30IntervalHourly: 'Últimos 30 días, cada hora',
            days30IntervalDaily: 'Últimos 30 días, diario',
            placeholder: 'Primera duración disponible'
        },
        defaultRadiosTable: 'Tabla de radios por defecto'
    }
}
